import { getStore } from "./store";
import type HeaderCharmType from "./schema/HeaderCharmType";

export default function getActiveCharm(): HeaderCharmType {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (8,5): Type 'HeaderCharmType | null' is not assignable to type 'HeaderCharmType'.
    // @ts-expect-error
    return getStore().activeCharm;
}
